import Datetime from '@/components/ext/datetime/datetime.vue'
import moment from 'moment'
import { EventBus } from '@/services/EventBus'

const formatView = 'MM-DD-YYYY HH:mm:ss.000'



export default {
    name: 'TimeInterval',
    props: {
      titleTextPath: {
        type: String,
        default: 'video.exportPeriod'
      }
    },
    data () {
        return {
            lang: this.$store.state.i18n.locale,
            start_date: moment().startOf('day').format(formatView),
            end_date: moment().endOf('day').format(formatView),
            format: formatView,
            error: false,
        }
    },
    components: {
        Datetime
    },
    computed: {
        errorDifferent() {
            return moment(this.end_date, this.format).isBefore(moment(this.start_date, this.format));
        },
    },
    methods: {
        saveVideo(){
            if(!this.error && !this.errorDifferent) {                
                this.$emit('save', {
                    start_date : moment(this.start_date, formatView),
                    end_date: moment(this.end_date, formatView)
                });
            }
        },
        getError(data) {
            this.error = data
        },
    },
}



// WEBPACK FOOTER //
// ./src/modules/timeInterval/timeInterval.js